import { render, staticRenderFns } from "./class_total_radar.vue?vue&type=template&id=439bfdbe"
import script from "./class_total_radar.vue?vue&type=script&lang=js"
export * from "./class_total_radar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports